import React, { Suspense, lazy } from 'react'

import "@fontsource/mulish";
import Homepage from "./pages/index";
import Header from './components/Header';
import { HelmetProvider } from 'react-helmet-async';
import { Routes, BrowserRouter as Router, Route } from "react-router-dom";
import { useEffect } from 'react';
import { buildVersion } from "./services/buildInfo";

// import { pageViewEvent } from "./services/adobeDataLayer";

import Thankyou from "./pages/thankyou";

function App() {

  // useEffect(() => {
  //   pageViewEvent("landing page");
  // }, [])

  useEffect(() => {
    // Initializing the Data Layer on the window object
    window.adobeDataLayer = window.adobeDataLayer || [];
    // Setting Page Level and user-specific variables
    window.adobeDataLayer.push({
      "event": "pageView",
      "web": {
        "webPageDetails": {
          "pageViews": {
            "value": 1
          },
          "name": "icicibank:in:en:campaign:accounts:casa:salcorpsavingsaccount:onboarding:landing page",

          "URL": window.location.href,
          "isErrorPage": "False",
        }
      },
      "_icicibank": {
        "channelInfo": {
          "version": buildVersion,
          "name": "nli",
        },
        "pageInfo": {
          "language": "en",
          "country": "in",
          "pageType": "campaign",
          "virtualPageView": "no vpv",
          "journey": "na",
          "subJourney": "na",
          "subSubJourney": "na",
        },
        "userInfo": {
          "userType": "na"
        },
        "errorInfo": {
          "errorType": "na",
          "errorDetails": "na"
        }
      }
    });

  }, [])

  return (
    <>
      <HelmetProvider>
        <Router basename={window.location.pathname}>
          <Header path="./dist/img/logo.webp" />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/thankyou" element={<Thankyou />} />
          </Routes>
        </Router>
      </HelmetProvider>

    </>
  );
}

export default App;
